
import React, { useState } from "react";
import { Box, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header2 from "../../../../components/dashboard/Header2";

const drawerWidth = 120;

const BusinessDashboard = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));

    return (
        <Box sx={{ display: "flex", minHeight: "100vh", width: "100vw" }}>
            {/* Header with Sidebar */}
            <Header2 isDrawerOpen={isDrawerOpen} onToggleDrawer={setIsDrawerOpen} />

            {/* Main Content */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    transition: "all 0.3s ease-in-out",
                    // marginLeft: isDrawerOpen && isLargeScreen ? `${drawerWidth}px` : "0",
                    width: isDrawerOpen && isLargeScreen ? `calc(100% - ${drawerWidth}px)` : "100%",
                    p: 2.5,
                }}
            >
                <Toolbar /> {/* Pushes content below the AppBar */}
                <Outlet />
            </Box>

            
        </Box>
    );
};

export default BusinessDashboard;
